import CONFIG from '../global/config';

class RestaurantSource {
  static async getAllRestaurants() {
    const response = await fetch(`${CONFIG.BASE_URL}/list`);
    const responseJson = await response.json();
    return responseJson.restaurants;
  }

  static async getRestaurantDetail(id) {
    const response = await fetch(`${CONFIG.BASE_URL}/detail/${id}`);
    const responseJson = await response.json();
    return responseJson.restaurant;
  }

  static async postReview(reviewData) {
    const response = await fetch(`${CONFIG.BASE_URL}/review`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reviewData),
    });
    const responseJson = await response.json();
    return responseJson.customerReviews;
  }
}

export default RestaurantSource;
